import { FolderIcon } from 'lucide-react';
import type { FileItem } from '../../../../../../types/File/File.types';
import { getFileIcon } from '../../../../../../utils/getFileIcon';

interface FileModalHeaderProps {
    file: FileItem;
}

export function FileModalHeader({ file }: FileModalHeaderProps) {
    const FileTypeIcon = file.type === 'folder' ? FolderIcon : getFileIcon(file.name);

    return (
        <div className="flex items-center justify-between border-b pb-4">
            <div className="flex items-center gap-2">
                <FileTypeIcon className="h-5 w-5" />
                <h2 className="text-xl font-semibold">{file.name}</h2>
            </div>
        </div>
    );
}
